import { utils } from "./utils.js";

var getYesNo = function(value) {
    if (value) {
        return "Yes";
    }

    return "No";
};

var getCreditRating = function(creditRatingValue) {
    if (creditRatingValue === "BelowAverage") {
        return "Below Average";
    }
    if (creditRatingValue === "Okay") {
        return "Average";
    }

    return creditRatingValue;
};

var getLicenseStatus = function(licenseStatusValue) {
    if (licenseStatusValue === "Valid" || licenseStatusValue === "Permit") {
        return "active";
    }
    if (licenseStatusValue === "Suspended" || licenseStatusValue === "Revoked") {
        return "suspended";
    }

    return "Expired";
};

var getAge = function(dateOfBirthYear, dateOfBirthMonth, dateOfBirthDay) {
    var today = new Date();
    var birthDate = new Date(dateOfBirthYear + "-" + dateOfBirthMonth + "-" + dateOfBirthDay);
    var age = today.getFullYear() - birthDate.getFullYear();
    var monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};

var visiquaUtils = {
    getDataQueryStringParameterValue: function(lead) {
        try {
            if (lead.insuranceType !== "AutoInsurance") {
                return null;
            }

            var data = {
                marital_status_37: getYesNo(lead.isMarried),
                current_insurance_company_31: lead.autoInsurance.currentInsurer,
                credit_rating_36: getCreditRating(lead.creditRating),
                license_status_42: getLicenseStatus(lead.autoInsurance.licenseStatus),
                //military_41:
                dui_34: getYesNo(lead.autoInsurance.dui),
                currently_insured_30: getYesNo(lead.autoInsurance.insuranceLengthInMonths > 0),
                need_sr_22_35: getYesNo(lead.autoInsurance.needsSr22),
                age_40: getAge(lead.dateOfBirthYear, lead.dateOfBirthMonth, lead.dateOfBirthDay),
                number_of_drivers: lead.autoInsurance.numberOfDrivers,
                gender_39: lead.gender,
                tickets_in_36_months_33: getYesNo(lead.autoInsurance.accidentsOrTicketsInPast3Years),
                homeowner_38: getYesNo(lead.currentResidenceType == "Own")
            };

            utils.log(data);

            var dataJson = JSON.stringify(data);
            utils.log(dataJson);

            var dataJsonBase64Encoded = btoa(dataJson);
            utils.log(dataJsonBase64Encoded);

            return dataJsonBase64Encoded;
        }
        catch (err) {
            // ignore
            utils.log(err);
        }

        return null;
    }
};

export { visiquaUtils }
